import { FormattedMessage } from 'react-intl';
import { FeatureList } from '.';
import { Feature } from '../models';
import { Button, Column, Box, BoxName, BoxDivider, BoxTitle, BoxTitleSmall } from './styled';
import { GroupTypesB2C } from '../helpers/product';

interface Props {
  nameKey: string;
  features: Feature[];
  price?: string;
  buttonTitleKey: string;
  onButtonClick?: () => any;
  swipeable?: boolean;
  loading?: boolean;
  hidden: boolean;
}

export const PlanBox = (props: Props) => (
  !props.hidden && (
    <Box swipeable={props.swipeable}>
      <BoxName>
        <FormattedMessage id={props.nameKey} />
      </BoxName>
      <BoxDivider />
      <BoxTitle>
        {
          props.nameKey === GroupTypesB2C.FREE_TRIAL ? (
            <FormattedMessage id="free_trial_title" values={{ br: <br /> }} />
          ) : (
            <>
              <BoxTitleSmall>
                <FormattedMessage id="starting_from" />
              </BoxTitleSmall>
              <br />
              <FormattedMessage id="month">{ month => <>{ `${props.price}/${month}` }</> }</FormattedMessage>
            </>
          )
        }
      </BoxTitle>
      <Column>
        <FeatureList features={props.features} />
      </Column>
      <Button onClick={props.onButtonClick} disabled={props.loading}>
        <FormattedMessage id={props.buttonTitleKey.toLowerCase()} />
        { props.loading && <i className="fa fa-spinner fa-pulse fa-fw" style={{ marginTop: '3px' }} /> }
      </Button>
      <br />
    </Box>
  )
);
